import React, { SVGProps } from 'react';

const BookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 4.79999H8.8C9.64869 4.79999 10.4626 5.13713 11.0627 5.73725C11.6629 6.33736 12 7.15129 12 7.99999V19.2C12 18.5635 11.7471 17.953 11.2971 17.5029C10.847 17.0528 10.2365 16.8 9.6 16.8H4V4.79999Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 4.79999H15.2C14.3513 4.79999 13.5374 5.13713 12.9373 5.73725C12.3371 6.33736 12 7.15129 12 7.99999V19.2C12 18.5635 12.2529 17.953 12.7029 17.5029C13.153 17.0528 13.7635 16.8 14.4 16.8H20V4.79999Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BookIcon;
